// import consts from '../../server/consts'
import consts from './consts'

const common = {}

common.sign = function (payment) {
  return (payment.type == 1 ? 1 : -1) * (payment.document == 3 ? -1 : 1)
}

common.signPrice = function (price, payment) {
  return common.sign(payment) * Math.abs(price)
}

common.subjectPriceDiscounted = function (s) {
  return s.price * (1 - s.discount / 100)
}

common.subjectPriceTotal = function (s) {
  return s.quantity * common.subjectPriceDiscounted(s)
}

common.calculatePaymentPrices = function (payment) {
  var price = 0
  var priceVAT = 0
  var priceTotal = 0
  payment.Subjects = payment.Subjects || []

  payment.Subjects.forEach(function (s) {
    s.quantity = Math.abs(s.quantity || 1)
    s.discount = Math.abs(s.discount || 0)
    s.price = Math.abs(s.price) // common.signPrice(s.price, payment)
    s.priceDiscounted = s.price * (1 - s.discount / 100)
    s.priceTotal = s.quantity * s.priceDiscounted
    price += s.priceTotal
  })

  if (payment.vatPercent) {
    price = price / (1 + payment.vatPercent / 100)
    priceVAT = price * payment.vatPercent / 100
  }

  priceTotal = price + priceVAT

  return {
    price: price.toFixed(2),
    priceVAT: priceVAT.toFixed(2),
    priceTotal: priceTotal.toFixed(2),
    subjectsTotalPrices: payment.Subjects.map(function (s) { return s.priceTotal.toFixed(2) })
  }
}

common.formatPrice = function (price, bgn) {
  return parseFloat(price).toFixed(2) + (bgn ? ' лв.' : '')
}

common.formatInvoiceNum = function (num) {
  return num ? Array(10 - num.toString().length + 1).join('0') + num : ''
}

common.invoiceSubjectText = function (subject, payment) {
  var text = consts.subjectType[payment.type][subject.type].title
  // console.log(subject)
  switch (parseInt(subject.type)) {
    case 1010:
      text = 'Абонамент ' + consts.subscriptionType[subject.subscriptionType].title + ' за ' + subject.year + ' година'
      break
    case 1020:
      text = 'Реклама "' + subject.format + '" в брой ' + consts.months[subject.month] + ' на ' + subject.data.name
      break
    case 1030:
      text = 'Научна литература "' + subject.data.title + '"'
      break
    case 1040:
      text = 'Такса научно събитие ' + subject.data.name
      break
    default:
      text = subject.description
      break
  }
  return text
}

common.formatSubjectMath = function (subject) {
  return subject.quantity + ' x ' + common.formatPrice(subject.priceDiscounted, true)
}

common.getYears = function (next) {
  var years = []
  var currentYear = new Date().getFullYear()
  var y
  if (next) {
    currentYear++
  }
  // console.log(currentYear, true)
  for (y = 2015; y <= currentYear; y++) {
    years.push(y)
  }
  return years
}

common.getYearsOptions = function (next) {
  return common.getYears(next).map(function (y) { return {id: y, title: y} })
}

// module.exports = common
export default common
